import types from "../ActionTypes/Index";

const initialState = {
  userInfo: {},
  labKey: "",
  Requisition: {},
  selectedTenantInfo: {},
  pageId: 0,
  refreshToken: null,
  adminId: null,
  baseUrl: null,
  labType: null,
  webInfo: null,
  notificationCounts: {
    newAccountRequest: 0,
    pendingRequisition: 0,
    salesRepRequest: 0,
  },
  userNotifications: [] as any[],
  notificationFunctionKeys: {} as Record<string, string>,
  unreadNotificationCount: 0,
  notificationsTotal: 0,
};

export interface Action {
  type: string;
  payload: string;
}

const Reducer = (state = initialState, action: Action) => {
  switch (action.type) {
    case types.SET_USER_INFO:
      return {
        ...state,
        userInfo: action.payload,
      };
    case types.SET_HEADERS_KEY:
      return {
        ...state,
        labKey: action.payload,
      };
    case types.SET_LAB_LOGO:
      return {
        ...state,
        labinfo: action.payload,
      };
    case types.SET_LAB_NAME:
      return {
        ...state,
        labname: action.payload,
      };
    case types.SET_FACILITY:
      return {
        ...state,
        facilityData: action.payload,
      };
    case types.SET_MULTI_FACILITIES:
      return {
        ...state,
        facilityInfo: action.payload,
      };
    case types.SET_FACILITY_CLAIMS:
      return {
        ...state,
        Menus: action.payload,
      };
    case types.SET_FACILITY_USER_TYPE:
      return {
        ...state,
        facilityUserType: action.payload,
      };
    case types.SET_LOGGEDIN_USER_INFO:
      return {
        ...state,
        loggedInInfo: action.payload,
      };
    case types.SET_DECRYPTION_ID:
      return {
        ...state,
        decryptionId: action.payload,
      };
    case types.SAVE_URLS:
      return {
        ...state,
        pdfurls: action.payload,
      };
    case types.TOKEN_DATA:
      return {
        ...state,
        token: action.payload,
      };
    case types.SELECTED_TENANT_INFO:
      return {
        ...state,
        selectedTenantInfo: action.payload,
      };
    case types.SET_LINKS_URLS:
      return {
        ...state,
        links: action.payload,
      };
    case types.SET_SELECTED_MENU:
      return {
        ...state,
        selectedMenuBreadCrum: action.payload,
      };

    case types.SET_REFRESH_TOKEN:
      return {
        ...state,
        refreshToken: action.payload,
      };
    case types.SET_ADMIN_USER_ID:
      return {
        ...state,
        adminId: action.payload,
      };
    case types.SET_BASE_URL:
      return {
        ...state,
        baseUrl: action.payload,
      };
    case types.SET_LABTYPE:
      return {
        ...state,
        labType: action.payload,
      };
    case types.SET_WEB_INFO:
      return {
        ...state,
        webInfo: action.payload,
      };
    case types.RESET_STORE:
      return initialState;
    case types.SET_NOTIFICATION_COUNTS:
      return {
        ...state,
        notificationCounts: action.payload,
      };
    case types.UPDATE_NOTIFICATION_COUNT:
      return {
        ...state,
        notificationCounts: {
          ...state.notificationCounts,
          ...(action.payload as any),
        },
      };
    case types.SET_NOTIFICATION_FUNCTION_KEYS:
      return {
        ...state,
        notificationFunctionKeys: (action.payload as any) ?? {},
      };
    case types.SET_UNREAD_NOTIFICATION_COUNT:
      return {
        ...state,
        unreadNotificationCount: Math.max(0, Number(action.payload) || 0),
      };
    case types.SET_USER_NOTIFICATIONS:
      return {
        ...state,
        userNotifications: (action.payload as any) ?? [],
      };
    case types.SET_NOTIFICATIONS_TOTAL:
      return {
        ...state,
        notificationsTotal: Math.max(0, Number(action.payload) || 0),
      };
    case types.APPEND_USER_NOTIFICATIONS: {
      const incoming = (action.payload as any) ?? [];
      if (!Array.isArray(incoming) || !incoming.length) {
        return state;
      }
      // A SignalR arrival can already have put a row in the list, and page
      // boundaries shift as new ones land, so drop ids we are already showing
      const existingIds = new Set(
        state.userNotifications.map((item: any) => item?.id)
      );
      const fresh = incoming.filter((item: any) => !existingIds.has(item?.id));
      if (!fresh.length) {
        return state;
      }
      return {
        ...state,
        userNotifications: [...state.userNotifications, ...fresh],
      };
    }
    case types.ADD_USER_NOTIFICATION: {
      const notification = action.payload as any;
      if (!notification) {
        return state;
      }
      // A notification can arrive over SignalR while the list is being fetched, so drop duplicates
      const isDuplicate = state.userNotifications.some(
        (item: any) => item?.id === notification?.id
      );
      const withoutDuplicate = state.userNotifications.filter(
        (item: any) => item?.id !== notification?.id
      );
      // A genuinely new unread notification bumps the badge by one. The list is
      // paged, so the server count cannot be recomputed from it.
      const isUnread = !isDuplicate && !notification?.seenAt;
      return {
        ...state,
        userNotifications: [notification, ...withoutDuplicate],
        unreadNotificationCount:
          state.unreadNotificationCount + (isUnread ? 1 : 0),
      };
    }
    case types.MARK_USER_NOTIFICATIONS_SEEN: {
      const { notificationIds, seenAt, isMarkedAllAsRead } =
        (action.payload as any) ?? {};

      // Mark all as read covers the notifications that are not loaded too, so
      // the whole list goes seen and the badge is cleared
      if (isMarkedAllAsRead) {
        return {
          ...state,
          userNotifications: state.userNotifications.map((item: any) =>
            item?.seenAt ? item : { ...item, seenAt }
          ),
          unreadNotificationCount: 0,
        };
      }

      if (!Array.isArray(notificationIds) || !notificationIds.length) {
        return state;
      }
      // Only the ones that were actually unread come off the badge
      const newlySeenCount = state.userNotifications.filter(
        (item: any) => notificationIds.includes(item?.id) && !item?.seenAt
      ).length;
      return {
        ...state,
        userNotifications: state.userNotifications.map((item: any) =>
          notificationIds.includes(item?.id) ? { ...item, seenAt } : item
        ),
        unreadNotificationCount: Math.max(
          0,
          state.unreadNotificationCount - newlySeenCount
        ),
      };
    }
    default:
      return state;
  }
};
export default Reducer;
